import { render, staticRenderFns } from "./NewRetirementTool.vue?vue&type=template&id=71d3334a"
import script from "./NewRetirementTool.vue?vue&type=script&lang=js"
export * from "./NewRetirementTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports